import { useQuery } from "@tanstack/react-query";
import { getAllProjects } from "../services/api-server/projects";
import { useTenantStore } from "../stores/tenantStore";

function useAllProjects() {
	const tenant = useTenantStore((state) => state.tenant);
	const tenantKey = tenant?.role_key;
	const tenantList = useTenantStore((state) => state.tenantList);

	return useQuery({
		queryKey: ["all-tenant-projects", tenantKey],
		queryFn: () =>
			getAllProjects(tenantKey, tenantList, {
				// closed: { $ne: true },
				// status: { $ne: "Resolved" },
			}),
		enabled: !!tenantKey && !!tenantList,
	});
}

export default useAllProjects;
